import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { usePlatformStore } from "@platform/store";
import { useFetchActions, getOrganizationsFromActions } from "@core/features/actions";
import { OrgAdminBanner } from "./OrgAdminBanner";

export function OrgAdminBannerContainer() {
  const { id } = useParams<{ id: string }>();
  const programId = id ? Number(id) : undefined;
  const user = usePlatformStore((s) => s.user);

  const { data: actionsData } = useFetchActions({
    programId,
    user,
    isEnabled: !!user,
  });

  const organizations = useMemo(
    () => getOrganizationsFromActions(actionsData?.actions ?? []),
    [actionsData?.actions]
  );

  return <OrgAdminBanner organizations={organizations} firstName={user?.first_name ?? null} />;
}

export default OrgAdminBannerContainer;
